import {
    DATABASE_REQUEST_GET,
    DATABASE_RESPONSE_GET_SUCCESS,
    DATABASE_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/databaseConstants";
  
  export const databaseShReducer = (state = { database: {} }, action) => {
    switch (action.type) {
      case DATABASE_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case DATABASE_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          database: action.payload,
        };
      case DATABASE_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  